import { FC } from 'react'
import ModuleMedallistPageComponent from '../ModuleMedallistPage'

const ModuleMedallistPage: FC<{
  moduleSpecificProps: any
}> = ({ moduleSpecificProps }) => {
  return (
    <ModuleMedallistPageComponent
      moduleSpecificProps={moduleSpecificProps}
    />
  )
}

export default ModuleMedallistPage
